module.exports = __webpack_public_path__ + "img/菜单_logo@3x.3cfc3c43.png";